<template>
    <!--@formatter:off-->
    <!-- [D] 신청 완료시 .done 추가, 알림 텍스트 활성화 -->
    <li
        class="lst_item"
        :class="{
            winning: isRegularAnswer,
            finish: isFullAnswers,
            end: isDisabled
        }"
        @click="checkTryAnswerWhenAnswerStateIsDenyAndValidateEnrolmentPeriod"
    >
        <div class="lst_tit_area">
            <em class="lst_tit">
                <span class="tit_txt">{{ program.programName }}</span>
            </em>
            <div class="area_badge">
                <span
                    v-show="isEnrolmentTypeDrawPrior && hasAnswer"
                    class="badge"
                    :class="{
                        choiceking1: priority === 1,
                        choiceking2: priority === 2,
                        choiceking3: priority >= 3,
                    }"
                >
                    {{$t('EnrolmentResponseProgram_priorityNo', {number: priority})}}
                </span>

                <span
                    v-show="
                        (isEnrolmentTypeRandom && hasAnswer) ||
                        (isEnrolmentTypeDrawPrior && !hasDrawResult && hasAnswer)
                    "
                    class="badge complete"
                >
                    {{$t('EnrolmentResponseProgram_applyComplete')}}
                </span>

                <span
                    v-show="isRegularAnswer"
                    class="badge winning"
                >
                    {{$t('EnrolmentResponseProgram_inRegular')}}
                </span>

                <span
                    v-show="isReservedAnswer"
                    class="badge spare"
                >
                    {{$t('EnrolmentResponseProgram_inReserved', {number: order})}}
                </span>

                <span
                    v-show="isEnrolmentTypeDrawPrior && hasDrawResult && !isRegularAnswer && !isReservedAnswer"
                    class="badge out"
                >
                    {{$t('EnrolmentResponseProgram_out')}}
                </span>
            </div>
            <dl
                v-if="isEnrolmentTypeFCFS"
                class="lst_state"
            >
                <dt>{{$t('EnrolmentResponseProgram_limit')}}</dt>
                <dd>
                    <span
                        :class="{
                            num: program.answerRegularCount > 0
                        }"
                    >{{program.answerRegularCount}}</span>/{{program.limit}}{{$t('EnrolmentResponseProgram_peopleUnit')}}
                </dd>
                <dt>{{$t('EnrolmentResponseProgram_reservedLimit')}}</dt>
                <dd>
                    <span
                        :class="{
                            num: program.answerReservedCount > 0
                        }"
                    >{{program.answerReservedCount}}</span>/{{program.reservedLimit}}{{$t('EnrolmentResponseProgram_peopleUnit')}}
                </dd>
            </dl>
            <dl
                v-else-if="hasLimit"
                class="lst_state"
            >
                <dt>{{$t('EnrolmentResponseProgram_limit')}}</dt><dd><span class="num">{{program.limit}}</span>{{$t('EnrolmentResponseProgram_peopleUnit')}}</dd>
                <dt>{{$t('EnrolmentResponseProgram_reservedLimit')}}</dt><dd><span class="num">{{program.reservedLimit}}</span>{{$t('EnrolmentResponseProgram_peopleUnit')}}</dd>
            </dl>
        </div>
        <div class="desc_wrap">
          <span class="desc_text">{{program.programDesc}}</span>
        </div>

        <div class="apply_area">
            <div v-if="program.times && program.times.length > 0" class="area_day">
                <ul>
                    <li
                        v-for="(time, index) in program.times"
                        :key="`time-${program.programNo}-${index}`"
                    >
                        <strong>{{getDayName(time.day)}}</strong>
                        {{getTimeText(time)}}
                    </li>
                </ul>
            </div>
            <div
                v-if="totalCost > 0"
                class="area_coat"
                :class="{open: isOpenDetail}"
            >
                <div
                    v-show="isOpenDetail"
                    class="detail_coat"
                >
                    <dl class="coat_total">
                        <dt>{{$t('EnrolmentResponseProgram_cost')}}</dt>
                        <dd>{{$t('EnrolmentResponseProgram_costUnit', {number: getCommaNumber({number: totalCost})})}}</dd>
                    </dl>
                    <ul class="coat_detail">
                        <li
                            v-for="(cost, index) in program.costs"
                            :key="`cost-${program.programNo}-${index}`"
                        >
                            <strong class="tit">{{cost.name}}</strong>
                            <div class="cont">{{$t('EnrolmentResponseProgram_costUnit', {number: getCommaNumber({number: cost.value})})}}</div>
                        </li>
                    </ul>
                </div>
                <button
                    type="button"
                    class="btn_coat"
                    @click.stop="isOpenDetail = !isOpenDetail"
                >
                    {{detailButtonText}}
                </button>
            </div>

            <div
                class="apply_area"
            >
                <button
                    v-show="!isAfterEnrolmentPeriod && !isFullAnswers"
                    type="button"
                    class="btn"
                    :class="{
                        btn_loader: isLoading,
                        bg: !hasAnswer,
                        line: hasAnswer,
                    }"
                    :disabled="answerStateType === answerStateTypeDeny"
                    @click="!isLoading && hasAnswer ? cancelAnswer() : applyAnswer()"
                >
                    <span
                        v-if="isLoading && !hasAnswer"
                    >
                        <span class="txt">{{$t('EnrolmentResponseProgram_applying')}}</span>
                        <span class="loader_area"><img :src="loadingSvgPath" :alt="$t('EnrolmentResponseProgram_loading')"></span>
                    </span>

                    <span
                        v-if="isLoading && hasAnswer"
                    >
                        <span class="txt">{{$t('EnrolmentResponseProgram_canceling')}}</span>
                        <span class="loader_area"><img :src="loadingBSvgPath" :alt="$t('EnrolmentResponseProgram_loading')"></span>
                    </span>

                    <span
                        v-show="!isLoading && hasAnswer"
                    >
                        <span class="txt">{{$t('EnrolmentResponseProgram_cancel')}}</span>
                        <span class="sp ico_arr"></span>
                    </span>

                    <span
                        v-show="!isLoading && !hasAnswer"
                    >
                        <span class="txt">{{$t('EnrolmentResponseProgram_apply')}}</span>
                        <span class="sp ico_arr"></span>
                    </span>
                </button>

                <span
                    v-if="isShowCurrentApplyPerson"
                    class="apply_state"
                    v-html="$t('EnrolmentResponseProgram_currentApplyPersons', {number: program.answerRegularCount})"
                >
                </span>

                <p v-show="isFullAnswers" class="desc_deadline">{{$t('EnrolmentResponseProgram_endedProgram')}}</p>
            </div>
        </div>

        <!-- 신청 취소 Confirm -->
        <div class="confirmVue" v-responseModal="isCancelConfirm && hasAnswer">
            <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                <div class="layer_box">
                    <div class="layer_content">
                        <em class="tit">{{$t('EnrolmentResponseProgram_confirmCancel')}}</em>
                    </div>
                    <!-- [D] 좌우 버튼의 크기가 다를 경우 type2 추가 -->
                    <ul class="btn_area type2">
                        <li><button type="button" class="btn btn_gray" @click="confirmNo">{{$t('common_no')}}</button></li>
                        <li><button type="button" class="btn" @click="confirmYes">{{$t('EnrolmentResponseProgram_doCancel')}}</button></li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 신청기간 이전 알림 Alert -->
        <div class="alertVue" v-responseModal="isBeforeEnrolmentPeriodAlert">
            <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                <div class="layer_box">
                    <div class="layer_content">
                        <em class="tit">{{$t('EnrolmentResponseProgram_noPeriod')}}</em>
                        <p class="desc">{{$t('EnrolmentResponseProgram_againInPeriod', {startDate: startDateString})}}</p>
                    </div>
                    <ul class="btn_area">
                        <li><button type="button" class="btn" @click.stop="alertOk">{{$t('common_confirm')}}</button></li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Confirm Vue (동의사항을 모두 동의하지 않은 상태로 수강 신청 시) -->
        <div class="confirmVue" v-responseModal="isAllAgreementsConfirm">
            <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                <div class="layer_box">
                    <div class="layer_content">
                        <p class="desc">
                            수강신청을 하려면 모든 개인정보 수집 및 이용 항목에 동의해야 합니다. 모두 동의하시겠습니까?
                        </p>
                    </div>
                    <!-- [D] 좌우 버튼의 크기가 다를 경우 type2 추가 -->
                    <ul class="btn_area type2">
                        <li>
                            <button type="button" class="btn btn_gray" @click="confirmAllAgreementsCancel">
                                {{$t('common_no')}}
                            </button>
                        </li>
                        <li>
                            <button type="button" class="btn" @click="confirmAllAgreementsOk">
                                동의합니다
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </li>
    <!--@formatter:on-->
</template>

<script>
import {ENROLMENT_TYPE} from '@/common/consts/survey.js';
import {ANSWER_TYPE, SURVEY_ANSWER_STATE_TYPE} from '@/common/consts/response.js';
import {getAssetInfo, PAGE_TYPE} from '@/common/consts/service.js';
import {toDateFromISOFormat, toResponseViewFormat} from '@/common/utils/date.js';
import checkTryAnswerWhenAnswerStateIsDeny from '@/common/mixins/checkTryAnswerWhenAnswerStateIsDeny.js';
import {showToast} from '@/common/utils/simpleToast.js';
import {responseModal} from '@/common/directives/responseModal.js';

import {
    APPLY_ANSWER,
    CANCEL_ANSWER,
    CHECK_ALL_AGREEMENTS,
    FORCE_CLOSE,
    IS_AFTER_ENROLMENT_PERIOD,
    IS_ALL_AGREEMENTS_CHECKED,
    IS_AVAILABLE_ENROLMENT_PERIOD,
} from '@/common/store/modules/enrolment/response.js';
import {createNamespacedHelpers} from 'vuex';
import {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';

const {mapState, mapGetters, mapActions} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: 'EnrolmentResponseProgram',
    directives: {responseModal},
    data() {
        return {
            isOpenDetail: false,

            answerStateTypeDeny: SURVEY_ANSWER_STATE_TYPE.DENY,
            loadingSvgPath: null,
            loadingBSvgPath: null,
            isBeforeEnrolmentPeriodAlert: false,
            isCancelConfirm: false,
            isAllAgreementsConfirm: false,
        };
        },
        props: {
            program: {
                type: Object,
                required: true
            },
            questionNo: {
                type: String,
                required: true
            }
        },

        mixins: [
            checkTryAnswerWhenAnswerStateIsDeny
        ],

        computed: {
            ...mapState({
                startDate: state => state.survey.startDate,
                startDateString: state => toResponseViewFormat(state.survey.startDate),
                endDate: state => state.survey.endDate,
                answerStateType: state => state.survey.answerStateType,
                enrolmentType: state => state.survey.enrolmentType,
                questions: state => state.survey.contents.questions,
                filterInfo: state => state.survey.contents.filterInfo,
                isPreview: state => state.options.isPreview,
                checkedAgreementsNos: state => state.options.checkedAgreementsNos,
            }),

            ...mapGetters({
                isAfterEnrolmentPeriod: IS_AFTER_ENROLMENT_PERIOD,
                isAvailableEnrolmentPeriod: IS_AVAILABLE_ENROLMENT_PERIOD,
                isAllAgreementsChecked: IS_ALL_AGREEMENTS_CHECKED,
            }),

            isWebView() {
                return this.$route.query.hasOwnProperty('isMasking');
            },

            totalCost() {
                return this.program.costs.reduce((sum, cost) => sum + (cost.value || 0), 0);
            },

            detailButtonText() {
                if (this.isOpenDetail) {
                    return this.$t('EnrolmentResponseProgram_closeDetail')
                } else {
                    return this.$t('EnrolmentResponseProgram_openDetail')
                }
            },

            /**
             * 수신자가 해당 프로그램에 대해 답변(신청)했는지 여부
             */
            hasAnswer() {
                return !!this.program.answer;
            },

            hasLimit() {
                return this.enrolmentType === ENROLMENT_TYPE.FCFS || this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
            },

            isEnrolmentTypeFCFS() {
                return this.enrolmentType === ENROLMENT_TYPE.FCFS;
            },

            isEnrolmentTypeRandom() {
                return this.enrolmentType === ENROLMENT_TYPE.RANDOM;
            },

            isEnrolmentTypeDrawPrior() {
                return this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
            },

            priority() {
                return this.program.answer?.priority;
            },

            order() {
                if (this.enrolmentType === ENROLMENT_TYPE.FCFS) {
                    return this.program.answer?.order;
                } else {
                    return this.program.drawResult?.order;
                }
            },

            isShowCurrentApplyPerson() {
                return !this.isAfterEnrolmentPeriod &&
                    (this.enrolmentType === ENROLMENT_TYPE.RANDOM || this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR);
            },

            /**
             * 해당 프로그램 정원(예비포함)이 모두 채워졌는지 여부
             */
            isFullAnswers() {
                if (this.isEnrolmentTypeDrawPrior) {
                    return false;
                }

                return !this.hasAnswer && (this.program.limit + this.program.reservedLimit <= this.program.answerTotalCount);
            },

            /**
             * 수신자가 정원내 신청한 경우
             */
            isRegularAnswer() {
                if (this.isEnrolmentTypeFCFS) {
                    return this.program.answer?.answerType === ANSWER_TYPE.REGULAR;
                } else if (this.isEnrolmentTypeDrawPrior) {
                    return this.program.drawResult?.drawResultType === ANSWER_TYPE.REGULAR;
                }

                return false;
            },

            /**
             * 수신자가 예비인원으로 신청한 경우
             */
            isReservedAnswer() {
                if (this.isEnrolmentTypeFCFS) {
                    return this.program.answer?.answerType === ANSWER_TYPE.RESERVED;
                } else if (this.isEnrolmentTypeDrawPrior) {
                    return this.program.drawResult?.drawResultType === ANSWER_TYPE.RESERVED;
                }

                return false;
            },

            hasDrawResult() {
                return !!this.program.drawResult;
            },

            /**
             * 해당 프로그램을 포함하고 있는 수강신청
             */
            getParentQuestion() {
                return this.questions.find(question => question.questionNo === this.questionNo);
            },

            /**
             * 수신자가 해당 프로그램 신청버튼을 클릭하고 서버 응답을 대기하고 있는 경우
             */
            isLoading() {
                return this.getParentQuestion.programs.find(program => program.programNo === this.program.programNo).isLoading;
            },

            /**
             * 해당 Question의 현재 신청완료된 갯수 + 신청로딩중인 갯수 >= 최대선택 갯수인 경우
             */
            isMaxChoiceAnswer() {
                const question = this.getParentQuestion;
                if (question.maxChoice === 0) {
                    return false;
                }

                const loadingProgramCount = question.programs.filter(program => program.isLoading).length;
                return question.choiceCount + loadingProgramCount >= question.maxChoice;
            },

            isDisabled() {
                return this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY || this.isAfterEnrolmentPeriod;
            }
        },

        methods: {
            ...mapActions({
                applyAnswerAction: APPLY_ANSWER,
                cancelAnswerAction: CANCEL_ANSWER,
                forceClose: FORCE_CLOSE,
                checkAllAgreements: CHECK_ALL_AGREEMENTS,
            }),

            getDayName(day) {
                return this.$t('EnrolmentResponseProgram_dayNames').split(',')[day];
            },

            getTimeText({startHour, startMinute, endHour, endMinute}) {
                const startHourText = this.getPadStartString({string: startHour});
                const startMinuteText = this.getPadStartString({string: startMinute});
                const endHourText = this.getPadStartString({string: endHour});
                const endMinuteText = this.getPadStartString({string: endMinute});

                return `${startHourText}:${startMinuteText}~${endHourText}:${endMinuteText}`;
            },

            getPadStartString({string}) {
                return (string || '00').padStart(2, '0');
            },

            getCommaNumber({number}) {
                return String(number || 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            },

            /**
             * 신청기간 이전 여부
             *     - 신청기간 이전에 페이지에 접속한 상태에서 시작시간이 되면 바로 값이 바뀌어야하기 때문에 getters로 사용하지 않음.
             * @returns {boolean}
             */
            isBeforeEnrolmentPeriod() {
                return Date.now() < toDateFromISOFormat(this.startDate);
            },

            /**
             * 신청하기
             */
            applyAnswer() {
                if (!this.validateApplyAnswer()) {
                    return;
                }

                if (!this.isAllAgreementsChecked) {
                    this.isAllAgreementsConfirm = true;
                    return;
                }

                if (this.isMaxChoiceAnswer) {
                    showToast(this.$t('EnrolmentResponseProgram_maxApply', {max: this.getParentQuestion.maxChoice}), this.isWebView);
                    return;
                }

                this.applyAnswerAction({
                    programNo: this.program.programNo
                });
            },

            validateApplyAnswer() {
                if (this.isPreview) {
                    return false;
                }

                //기간이 종료된 수강신청의 경우
                if (this.isAfterEnrolmentPeriod) {
                    this.forceClose();
                    return false;
                }

                //신청기간 이전인 경우
                if (this.isBeforeEnrolmentPeriod()) {
                    this.isBeforeEnrolmentPeriodAlert = true;
                    return false;
                }

                return true;
            },

            /**
             * 신청 취소
             */
            cancelAnswer() {
                if (Date.now() > toDateFromISOFormat(this.endDate)) {
                    this.forceClose();
                    return;
                }

                this.isCancelConfirm = true;
            },

            /**
             * 신청 취소 confirm 확인
             */
            confirmYes() {
                this.cancelAnswerAction({
                    surveyAnswerNo: this.program.answer.surveyAnswerNo,
                    programNo: this.program.programNo
                })
                .then(() => {
                    this.isCancelConfirm = false;
                    showToast(this.$t('EnrolmentResponseProgram_enrolmentCanceled'), this.isWebView);
                });
            },

            /**
             * 신청 취소 confirm 취소
             */
            confirmNo() {
                this.isCancelConfirm = false;
            },

            /**
             * 신청기간 이전인 경우 노출되는 alert 에 대한 확인 버튼 동작
             */
            alertOk() {
                this.isBeforeEnrolmentPeriodAlert = false;
            },

            /**
             * 응답상태가 신청안함 상태인데 프로그램을 클릭한 경우
             */
            checkTryAnswerWhenAnswerStateIsDenyAndValidateEnrolmentPeriod(event) {
                if (this.answerStateType !== SURVEY_ANSWER_STATE_TYPE.DENY) {
                    return;
                }

                if (!this.validateApplyAnswer()) {
                    return;
                }

                this.checkTryAnswerWhenAnswerStateIsDeny(event);
            },

            /**
             * 동의문 확인 팝업 - 확인 버튼
             */
            confirmAllAgreementsCancel() {
                this.isAllAgreementsConfirm = false;
            },

            /**
             * 동의문 확인 팝업 - 취소 버튼
             */
            confirmAllAgreementsOk() {
                this.checkAllAgreements()
                    .then(() => {
                        this.isAllAgreementsConfirm = false;
                        this.applyAnswer();
                    });
            },
        },

        created() {
            const assetInfo = getAssetInfo(this.$route.query.serviceId, PAGE_TYPE.RESPONSE);
            assetInfo.assets.loading.then(path => {
                this.loadingSvgPath = path.default;
            });

            assetInfo.assets.loadingB.then(path => {
                this.loadingBSvgPath = path.default;
            });
        },

    }
</script>

<style scoped lang="scss">
.desc_wrap {
  .desc_text {
    color: #666;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}
</style>
